import { Howl } from "howler"

import { makeAutoObservable } from "mobx"
import { pickRandom } from "react-sdk/utils"

class Sound {
  constructor(json) {
    Object.assign(this, json)
    makeAutoObservable(this)
  }
}

class SoundPlayer {

  all = []


  constructor() {
    // 2 players : un pour la msique, un pour le son (comme ca les sons peuvent être joués en meme tps que la zik)

    /** @type <Howl> */
    this.musicPlayer = null

    // /** @type <Howl> */
    // this.sfxPlayer = null

  }

  init(json) {
    this.all = json
    .filter(elem => elem.id).map(elem => new Sound(elem))
  }

  get ids() { return this.all.map(c => c.id)}


  get(id) { return this.all.find(c => c.id === id) }


  playSound(id, callback = null) {

    let s = this.get(id)
    if(!s) return

    if(s.type === "musicRandom") {
      let _id = pickRandom(s.path.split('|'))
      this.playSound(_id)
    }

    if(s.type === "music") {
      if(this.musicPlayer) this.musicPlayer.stop()

      let root = window.CONFIG.root

      let src = [`${root}${s.path}.mp3`, `${root}${s.path}.ogg`]

      this.musicPlayer = new Howl({
        src: src,
        autoplay: true,
        loop: true,
        volume: s.volume || 1
      })
    }

    if(s.type === "sfx") {
      // if(this.sfxPlayer) this.sfxPlayer.stop()
      // NOTE on ne fait plus stop sur le son d'avant, on veut pouvoir en lire plusieurs en même temps
      let root = window.CONFIG.root
      let src = [`${root}${s.path}.mp3`, `${root}${s.path}.ogg`]
      let sfx =  new Howl({
        src: src,
        autoplay: true,
        loop: false,
        volume: s.volume || 1,
        onend: callback
      })

    }

  }

  stop() {
    if(this.musicPlayer) {
      this.musicPlayer.stop()
      this.musicPlayer.unload()
      this.musicPlayer = null

    }
    // if(this.sfxPlayer) {
    //   this.sfxPlayer.stop()
    //   this.sfxPlayer.unload()
    //   this.sfxPlayer = null
    // }
  }

  pause() {
    if(this.musicPlayer) this.musicPlayer.pause()

  }
  unpause() {
    if(this.musicPlayer) this.musicPlayer.play()

  }
}


export default new SoundPlayer()
